import { useRef } from "react";

export function useHiddenErr() {
  const hiddenErr = useRef<Set<string>>(null);
  if (hiddenErr.current === null) {
    //@ts-ignore
    hiddenErr.current = new Set();
  }

  const updateHiddenError = (name: string, value?: any) => {
    if (value === undefined) {
      hiddenErr.current?.delete(name);
    } else {
      hiddenErr.current?.add(name);
    }
  };

  const clearHiddenError = () => {
    hiddenErr.current?.clear();
  };

  return { hiddenErr, updateHiddenError, clearHiddenError };
}
